var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#ed79aa",
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.452 8.929l-1.87 1.883a7.238 7.238 0 00-5.152-2.149c-3.915 0-7.11 3.11-7.278 7.01h-.008v7.122A10.003 10.003 0 016.5 16c0-5.523 4.446-10 9.93-10a9.865 9.865 0 017.022 2.929zm0 14.142A9.865 9.865 0 0116.592 26v-2.664a7.238 7.238 0 004.99-2.147z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.681 24.784v-9.11h.007C11.828 13.069 13.97 11 16.592 11c2.712 0 4.911 2.214 4.911 4.946 0 2.731-2.199 4.945-4.91 4.945a4.862 4.862 0 01-2.483-.677v5.511a9.822 9.822 0 01-2.429-.94zm4.911-6.338a2.491 2.491 0 002.483-2.5c0-1.381-1.112-2.5-2.483-2.5a2.491 2.491 0 00-2.482 2.5c0 1.38 1.111 2.5 2.482 2.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPink);
export default __webpack_public_path__ + "static/media/pink.d0234539afefdb27b0c0956829030eb5.svg";
export { ForwardRef as ReactComponent };